<div [ngClass]="clazz" class="">
  <div class="d-flex flex-col">
    @for (eaNew of news; track eaNew; let indexOfelement = $index) {
      @if (indexOfelement < 2) {
        <ea-new
          [eaNew]="eaNew"
          prLoader
          [loading]="loading"
          [ngClass]="{ fill: eaNew.fill }"
        ></ea-new>
      }
    }
  </div>
  @if (withSmall) {
    <div class="d-flex flex-col">
      @for (eaNew of news; track eaNew; let indexOfelement = $index) {
        @if (indexOfelement >= 2 && indexOfelement < 4) {
          <ea-new-small
            [eaNewSmall]="eaNew"
            prLoader
            [loading]="loading"
            [ngClass]="{ fill: eaNew.fill }"
          ></ea-new-small>
        }
      }
    </div>
  }
</div>
